const mime = {
  routes: [
    {
      path: '/mime/list/:type',
      name: 'mimeList',
      meta: {
        isShowHeader: true,
        keepAlive: false,
        breadcrumb: [
          {
            name: '首页',
            path: '/index'
          },
          {
            name: '个人中心'
          }
        ]
      },
      component: () => import('@/project/views/mime/list')
    },
    {
      path: '/mime/changePhone',
      name: 'ChangePhone',
      meta: {
        isShowHeader: true,
        keepAlive: false,
        breadcrumb: [
          {
            name: '首页',
            path: '/index'
          },
          {
            name: '修改手机号',
            path: '/mime/changePhone'
          }
        ]
      },
      component: () => import('@/project/views/mime/change-phone')
    },
    {
      path: '/mime/changePassword',
      name: 'changePassword',
      meta: {
        isShowHeader: true,
        keepAlive: false,
        breadcrumb: [
          {
            name: '首页',
            path: '/index'
          },
          {
            name: '修改密码',
            path: '/mime/changePassword'
          }
        ]
      },
      component: () => import('@/project/views/mime/change-password')
    },
    {
      path: '/mime/invoiceShow/:id',
      name: 'invoiceShow',
      meta: {
        isShowHeader: true,
        keepAlive: false,
        breadcrumb: [
          {
            name: '首页',
            path: '/index'
          },
          {
            name: '个人中心',
            path: '/mime/list/个人中心'
          }
        ]
      },
      component: () => import('@/project/views/mime/invoice-show')
    },
    {
      path: '/issueInvoice',
      name: 'issueInvoice',
      meta: {
        isShowHeader: true,
        keepAlive: false,
        breadcrumb: [
          {
            name: '首页',
            path: '/index'
          },
          {
            name: '个人中心',
            path: '/mime/list/我的发票'
          }
        ]
      },
      component: () => import('@/project/views/mime/issue-invoice')
    },
    {
      path: '/entrust',
      name: 'entrust',
      meta: {
        isShowHeader: true,
        keepAlive: false,
        breadcrumb: [
          {
            name: '首页',
            path: '/index'
          },
          {
            name: '我的委托',
            path: '/entrust'
          }
        ]
      },
      component: () => import('@/project/views/mime/entrust')
    }
  ]
}
export default mime



// WEBPACK FOOTER //
// ./src/project/router/mime.js